import { RadioButtonCheckedIcon, RadioButtonUncheckedIcon } from '@shared/components';

export interface MockRadioButtonIconProps {
  selected?: boolean;
}

export default function MockRadioButtonIcon(props: Readonly<MockRadioButtonIconProps>) {
  const { selected = false } = props;
  if (selected) {
    return (
      <RadioButtonCheckedIcon
        sx={(theme) => ({ color: theme.palette.primary.main, cursor: 'not-allowed' })}
      />
    );
  }
  return (
    <RadioButtonUncheckedIcon
      sx={(theme) => ({ color: theme.palette.grey[400], cursor: 'not-allowed' })}
    />
  );
}
